export let storeLoginUser = function (response) {
  // 保存服务端返回的token、用户id
  localStorage.setItem(
    response.data.u_id + "token",
    response.data.token
  );
  try {
    let apis = {};
    let attachApi = null;
    for (var i in response.data.api) {
      const apiUri =
        response.data.api[i].domain +
        (response.data.api[i].port != 80 ?
          ":" + response.data.api[i].port :
          "");
      if (response.data.api[i].type_id == 2) {
        attachApi = apiUri;
      }
      apis["api_" + response.data.api[i].type_id] = apiUri;
    }
    if (!apis["api_3"]) {
      apis["api_3"] = attachApi || this.Conf.serverPre;
    }
    if (!apis["api_4"]) {
      apis["api_4"] = attachApi || this.Conf.serverPre;
    }
    localStorage.setItem("api", JSON.stringify(apis));
  } catch (e) {}

  localStorage.setItem("ws", JSON.stringify(response.data.ws));
  localStorage.setItem("u_id", response.data.u_id);
  if (response.data.configs) {
    localStorage.setItem(
      "configs",
      JSON.stringify(response.data.configs)
    );
  }
}
let emojiListCom = [
  //表情包和表情路径
  {
    title: "[唉]",
    url: "a.gif"
  },
  {
    title: "[挨打]",
    url: "aida.gif"
  },
  {
    title: "[闭嘴]",
    url: "bizui.gif"
  },
  {
    title: "[馋嘴]",
    url: "chanzui.gif"
  },
  {
    title: "[抽泣]",
    url: "chouqi.gif"
  },
  {
    title: "[聪明]",
    url: "congming.gif"
  },
  {
    title: "[猝死]",
    url: "cusi.gif"
  },
  {
    title: "[捣蛋]",
    url: "daodan.gif"
  },
  {
    title: "[恶魔]",
    url: "emo.gif"
  },
  {
    title: "[高兴]",
    url: "gaoxing.gif"
  },
  {
    title: "[鬼]",
    url: "gui.gif"
  },
  {
    title: "[海盗]",
    url: "haidao.gif"
  },
  {
    title: "[害羞]",
    url: "haixiu.gif"
  },
  {
    title: "[坏笑]",
    url: "huaixiao.gif"
  },
  {
    title: "[挤眼]",
    url: "jiyan.gif"
  },
  {
    title: "[拒绝]",
    url: "jujue.gif"
  },
  {
    title: "[可爱]",
    url: "keai.gif"
  },
  {
    title: "[可怜]",
    url: "kelian.gif"
  },
  {
    title: "[酷]",
    url: "ku.gif"
  },
  {
    title: "[困]",
    url: "kun.gif"
  },
  {
    title: "[劳累]",
    url: "laolei.gif"
  },
  {
    title: "[泪]",
    url: "lei.gif"
  },
  {
    title: "[冷]",
    url: "leng.gif"
  },
  {
    title: "[流口水]",
    url: "liukoushui.gif"
  },
  {
    title: "[美]",
    url: "mei.gif"
  },
  {
    title: "[难过]",
    url: "nanguo.gif"
  },
  {
    title: "[难受]",
    url: "nanshou.gif"
  },
  {
    title: "[怒]",
    url: "nu.gif"
  },
  {
    title: "[怒骂]",
    url: "numa.gif"
  },
  {
    title: "[钱]",
    url: "qian.gif"
  },
  {
    title: "[庆祝]",
    url: "qingzhu.gif"
  },
  {
    title: "[亲亲]",
    url: "qinqin.gif"
  },
  {
    title: "[色]",
    url: "se.gif"
  },
  {
    title: "[上瞟]",
    url: "shangpiao.gif"
  },
  {
    title: "[生病]",
    url: "shengbing.gif"
  },
  {
    title: "[受伤]",
    url: "shoushang.gif"
  },
  {
    title: "[瞌睡]",
    url: "shui.gif"
  },
  {
    title: "[天使]",
    url: "tianshi.gif"
  },
  {
    title: "[吐]",
    url: "tu.gif"
  },
  {
    title: "[哇]",
    url: "wa.gif"
  },
  {
    title: "[哇哦]",
    url: "waou.gif"
  },
  {
    title: "[想吐]",
    url: "waou.gif"
  },
  {
    title: "[向下看]",
    url: "xiangxiakan.gif"
  },
  {
    title: "[想想]",
    url: "xiangxiang.gif"
  },
  {
    title: "[笑]",
    url: "xiao.gif"
  },
  {
    title: "[笑哭]",
    url: "xiaoku.gif"
  },
  {
    title: "[心]",
    url: "xin.gif"
  },
  {
    title: "[幸福]",
    url: "xingfu.gif"
  },
  {
    title: "[醒醒]",
    url: "xingxing.gif"
  },
  {
    title: "[心碎]",
    url: "xinsui.gif"
  },
  {
    title: "[心嘘]",
    url: "xu.gif"
  },
  {
    title: "[摇头]",
    url: "yaotou.gif"
  },
  {
    title: "[晕]",
    url: "yun.gif"
  },
  {
    title: "[张望]",
    url: "zhangwang.gif"
  },
  {
    title: "[左右看]",
    url: "zuoyoukan.gif"
  },
  {
    title: "[来]",
    url: "lai.gif"
  },
  {
    title: "[好的]",
    url: "ok.gif"
  },
  {
    title: "[拍手]",
    url: "paishou.gif"
  },
  {
    title: "[强]",
    url: "qiang.gif"
  },
  {
    title: "[耶]",
    url: "ye.gif"
  },
  {
    title: "[赞]",
    url: "zan.gif"
  },
  {
    title: "[弱]",
    url: "ruo.gif"
  },
];
const OwOlistUrlCom = "./static/emot/image/"; // 表情包地址
export let emojiList = emojiListCom;
export let OwOlistUrl = OwOlistUrlCom;
export let analyzeEmoji = function (cont) {
  //编译表情替换成图片展示出来
  var pattern1 = /\[[\u4e00-\u9fa5]+\]/g;
  var pattern2 = /\[[\u4e00-\u9fa5]+\]/;
  var content = cont.match(pattern1);
  var str = cont;
  if (content) {
    for (var i = 0; i < content.length; i++) {
      for (var j = 0; j < emojiListCom.length; j++) {
        if (emojiListCom[j].title == content[i]) {
          var src = emojiListCom[j].url;
          break;
        }
      }
      str = str.replace(
        pattern2,
        '<img class="emoji" src="' + OwOlistUrl + src + '"/>'
      );
    }
  }
  return str;
}
export let compUploadImg = function (file, callbak) {
  let imgData = null;
  let filesizelimit = 2048;
  if (localStorage.getItem("configs")["fileSize"]) {
    filesizelimit = parseInt(localStorage.getItem("configs")["fileSize"]);
  }
  if (file.file.size > filesizelimit){
  let canvas = document.createElement("canvas"); // 创建Canvas对象(画布)
  let context = canvas.getContext("2d");
  let img = new Image();
  img.src = file.content; // 指定图片的DataURL(图片的base64编码数据)
  img.onload = () => {
    var quality = 0.7;
    const cw = parseInt(img.width * quality);
    const ch = parseInt(img.height * quality);
    canvas.width = cw;
    canvas.height = ch;
    context.drawImage(img, 0, 0, cw, ch);
    callbak(canvas.toDataURL(file.file.type, quality)) 
  };
  }
}



// WEBPACK FOOTER //
// ./src/utils/chat.js